import { Employee } from 'modules/core/hooks/useCurrentSession'
import hasFeature from 'modules/core/lib/hasFeature'

export const hasRegularAccessOrNotEmployee = (employee: Employee) =>
  !employee || !hasFeature('employee_onboarding') || employee.hasRegularAccess

export const canAccessWelcomeSpace = (employee: Employee) => {
  if (!employee) {
    return false
  }

  return !employee.isTerminating && !employee.hasRegularAccess && hasFeature('employee_onboarding')
}
